__turbopack_context__.v({
  "checkbox": "ApplyOpenCallRequirements-module__f2qp9q__checkbox",
  "checkboxIcon": "ApplyOpenCallRequirements-module__f2qp9q__checkboxIcon",
  "column": "ApplyOpenCallRequirements-module__f2qp9q__column",
  "columns": "ApplyOpenCallRequirements-module__f2qp9q__columns",
  "container": "ApplyOpenCallRequirements-module__f2qp9q__container",
  "error": "ApplyOpenCallRequirements-module__f2qp9q__error",
  "fadeInItems": "ApplyOpenCallRequirements-module__f2qp9q__fadeInItems",
  "requirement": "ApplyOpenCallRequirements-module__f2qp9q__requirement",
  "requirementTitle": "ApplyOpenCallRequirements-module__f2qp9q__requirementTitle",
  "spacing--lg": "ApplyOpenCallRequirements-module__f2qp9q__spacing--lg",
  "spacing--md": "ApplyOpenCallRequirements-module__f2qp9q__spacing--md",
  "spacing--sm": "ApplyOpenCallRequirements-module__f2qp9q__spacing--sm",
  "spacing--xl": "ApplyOpenCallRequirements-module__f2qp9q__spacing--xl",
  "spacing--xs": "ApplyOpenCallRequirements-module__f2qp9q__spacing--xs",
  "spacing--xxl": "ApplyOpenCallRequirements-module__f2qp9q__spacing--xxl",
  "spacing--xxs": "ApplyOpenCallRequirements-module__f2qp9q__spacing--xxs",
  "spacing--xxxl": "ApplyOpenCallRequirements-module__f2qp9q__spacing--xxxl",
  "spacing--xxxs": "ApplyOpenCallRequirements-module__f2qp9q__spacing--xxxs",
  "text": "ApplyOpenCallRequirements-module__f2qp9q__text",
  "title": "ApplyOpenCallRequirements-module__f2qp9q__title",
});
